var map = {
	"./Slide 1.jpg": 2058,
	"./Slide 2.jpg": 5938,
	"./slide 10.jpg": 4271,
	"./slide 11.jpg": 696,
	"./slide 12.jpg": 8171,
	"./slide 13.jpg": 3439,
	"./slide 14.jpg": 1772,
	"./slide 15.jpg": 9023,
	"./slide 3.jpg": 8267,
	"./slide 5.jpg": 2955,
	"./slide 6.jpg": 7519,
	"./slide 7.jpg": 1745,
	"./slide 8.jpg": 2656,
	"./slide 9.jpg": 9238,
	"./slide4.jpg": 7616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2473;